export enum MemberType {
  USER = "USER",
  LIBRUARY = "LIBRUARY",
}

export enum MemberStatus {
  ACTIVE = "ACTIVE",
  BLOCK = "BLOCK",
  DELETE = "DELETE",
}
